import {SelectOptionsType} from 'global';
import {useGetAllItemStatusesByBoardId} from 'hooks';
import React, {useEffect, useMemo} from 'react';
import {AppControlledAutoComplete, AppControlledAutoCompleteProps} from './AutoComplete';

interface AppStatusSelectProps extends Omit<AppControlledAutoCompleteProps, 'options' | 'value'> {
    boardSlug?: string;
}

export const AppStatusSelect: React.FC<AppStatusSelectProps> = ({boardSlug, ...props}) => {
    const {getAllItemStatuses, getAllStatusesLoading, getAllStatusessResponse} = useGetAllItemStatusesByBoardId();

    useEffect(() => {
        if (boardSlug) {
            getAllItemStatuses({
                variables: {
                    boardSlug: boardSlug,
                },
            });
        }
    }, [boardSlug]);

    const statusOptions: SelectOptionsType[] = useMemo(() => {
        if (getAllStatusessResponse) {
            return getAllStatusessResponse.map(x => ({
                label: x.title,
                value: x.id,
            }));
        }
        return [];
    }, [getAllStatusessResponse]);

    return <AppControlledAutoComplete loading={getAllStatusesLoading} options={statusOptions} {...props} />;
};

export default AppStatusSelect;
